import axios from "axios";
import axiosInstance from "./AxiosInstance";

// Get reports for a patient
export async function getReports(patientId, searchTerm = "") {
  try {
    const response = await axiosInstance.post(`/patient/getReports`, {
      patient_id: patientId,
      search: searchTerm,   // ⬅️ ADD HERE
    });
    return response;
  } catch (error) {
    console.error("Error fetching reports:", error);
    throw error;
  }
}

// Send report link to patient or doctor
export async function sendReportLink(linkData) {
  try {
    const response = await axiosInstance.post(
      `/patient/sendReportLink`,
      linkData
    );
    return response;
  } catch (error) {
    console.error("Error sending report link:", error);
    throw error;
  }
}

// Upload report
export async function uploadReport(formData) {
  try {
    const response = await axiosInstance.post(
      `/patient/uploadReport`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error uploading report:", error);
    throw error;
  }
}

// Edit Report
export async function editReport(formData) {
  try {
    const response = await axiosInstance.post(
      `/patient/editReport`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  } catch (error) {
    console.error("Error editing report:", error);
    throw error;
  }
}

// Delete Report
export async function deleteReport(reportId) {
  try {
    const response = await axiosInstance.post(`/patient/deleteReport`, {
      report_id: reportId,
    });
    return response;
  } catch (error) {
    console.error("Error deleting report:", error);
    throw error;
  }
}

export function deleteReportFile(report_file_id) {
  return axiosInstance.post("/patient/deleteReportFile", {
    report_file_id,
  });
}